import { KeyRound } from 'lucide-react'
import { useState } from 'react'
import { useAuth } from './AuthContext'

/** Première connexion : le mot de passe temporaire doit être remplacé (imposé par le serveur). */
export function PasswordChangePage() {
  const auth = useAuth()
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [confirm, setConfirm] = useState('')
  const [pending, setPending] = useState(false)
  const mismatch = confirm !== '' && confirm !== next

  return (
    <main className="op-screen op-screen--center">
      <form
        className="op-card op-login"
        onSubmit={(event) => {
          event.preventDefault()
          if (mismatch || next.length < 12) return
          setPending(true)
          auth
            .replaceTemporaryPassword(current, next)
            .catch(() => undefined)
            .finally(() => {
              setPending(false)
            })
        }}
      >
        <h1>Choisissez votre mot de passe</h1>
        <p className="op-muted">
          Votre mot de passe temporaire doit être remplacé avant de commencer. Au moins 12 caractères.
        </p>
        <label className="op-field">
          <span>Mot de passe temporaire</span>
          <input
            type="password"
            autoComplete="current-password"
            value={current}
            onChange={(event) => {
              setCurrent(event.target.value)
            }}
            required
          />
        </label>
        <label className="op-field">
          <span>Nouveau mot de passe</span>
          <input
            type="password"
            autoComplete="new-password"
            minLength={12}
            value={next}
            onChange={(event) => {
              setNext(event.target.value)
            }}
            required
          />
        </label>
        <label className="op-field">
          <span>Confirmer le nouveau mot de passe</span>
          <input
            type="password"
            autoComplete="new-password"
            value={confirm}
            aria-invalid={mismatch}
            onChange={(event) => {
              setConfirm(event.target.value)
            }}
            required
          />
        </label>
        {mismatch ? <p className="op-error">Les deux mots de passe ne correspondent pas.</p> : null}
        {auth.error ? (
          <p className="op-error" role="alert">
            {auth.error}
          </p>
        ) : null}
        <button type="submit" className="field-button field-button--primary field-button--tall" disabled={pending}>
          <KeyRound aria-hidden="true" /> {pending ? 'Enregistrement…' : 'Enregistrer et continuer'}
        </button>
        <button
          type="button"
          className="field-button field-button--outline"
          onClick={() => void auth.signOut()}
        >
          Se déconnecter
        </button>
      </form>
    </main>
  )
}
